import { Component, OnInit } from '@angular/core';
import moment from 'moment';
import { PipeImportService } from '@services/pipe-imports/pipe-import.service';
import { DataTableEvent } from '../../components/data-table/data-table.component';
import { Router } from '@angular/router';

@Component({
    selector: 'app-failed-pipe-imports',
    templateUrl: './failed-pipe-imports.component.html',
    styleUrls: ['./failed-pipe-imports.component.scss'],
    providers: [PipeImportService],
    standalone: false
})
export class FailedPipeImportsComponent implements OnInit {

  public columns = [
    { prop: 'title', name: 'Title' },
    { prop: 'typeTitle', name: 'Type Title' },
    {
      prop: 'lastSuccessed', name: 'Last Successed', valueTransformer: function(date) {
        return moment(date).format('DD-MM-YYYY  HH:mm');
      }
    },
    {
      prop: 'lastFailed', name: 'Last Failed', valueTransformer: function(date) {
        return moment(date).format('DD-MM-YYYY  HH:mm');
      }
    },
    { prop: 'failCount', name: 'Fail Count' }
  ];

  public params: any;

  constructor(
    public pipeImportService: PipeImportService,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.params = {
      wasLastSuccessful: false
    };
  }

  public onDetail(event: DataTableEvent): void {
    this.router.navigate(['pipe-imports', event.row._id]);
  }

  public onCustom(event: DataTableEvent): void {
    this.router.navigate(['pipe-imports/', event.row._id, 'logs']);
  }

}
